import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import { oadLX } from '@mtfe/sweet-oad';
import { Describe } from '@mtfe/sweet-components';
import style from './style.less';
import tpl from './dom.html';
import TabsPane from '../common/TabsPane/script';
import DailyDeals from '../DailyDeals/script';
import OptionalWelfare from '../OptionalWelfare/script';
import store from '../../store/index';

const { storeDailyDeals, storeOptionalWelfare } = store.storeCoupon;

const { createUniqueId, isFunction } = common;
const optionalWelfareMC = 'b_waimai_vwpdtsur_mc';
const dailyDealsMC = 'b_waimai_889mwdc5_mc';
const couponComponentID = 'waimai_5podn25d';

const wrapperID = createUniqueId();
const labelID = createUniqueId();

const dailyDealsActive = () => {
    oadLX.mc(dailyDealsMC);
    const dailyDealsIDDom = dom.$id(storeDailyDeals.tabsContainerID);
    const optionalWelfareDom = dom.$id(storeOptionalWelfare.tabsContainerID);
    const wrapperDom = dom.$id(wrapperID);
    const labelDom = dom.$id(labelID);

    wrapperDom.children[0].style.display = '';
    wrapperDom.children[1].style.display = 'none';
    labelDom.children[0].classList.add(style.active);
    labelDom.children[1].classList.remove(style.active);
    dailyDealsIDDom.style.display = '';
    optionalWelfareDom.style.display = 'none';
};
const optionalWelfareActive = () => {
    oadLX.mc(optionalWelfareMC);
    const dailyDealsDom = dom.$id(storeDailyDeals.tabsContainerID);
    const optionalWelfareDom = dom.$id(storeOptionalWelfare.tabsContainerID);
    const wrapperDom = dom.$id(wrapperID);
    const labelDom = dom.$id(labelID);

    wrapperDom.children[0].style.display = 'none';
    wrapperDom.children[1].style.display = '';
    labelDom.children[0].classList.remove(style.active);
    labelDom.children[1].classList.add(style.active);
    dailyDealsDom.style.display = 'none';
    optionalWelfareDom.style.display = '';
};
const CouponComponentReady = () => {
    eventBus.$on('CouponComponentReady', () => {
        eventBus.$emit('DailyDealsReady');
        eventBus.$emit('OptionalWelfareReady');
    });
};

const describeCouponComponent = new Describe('CouponComponent', couponComponentID);
const CouponComponent = async (props = {}) => {
    // 暂不支持手动更改defaultActiveKey
    const { defaultActiveKey = storeDailyDeals.recallBizId, onClickTabsLabelCb } = props;

    const data = {
        wrapperID,
        labelID,
        dailyDealsID: storeDailyDeals.recallBizId,
        optionalWelfareID: storeOptionalWelfare.recallBizId,
        dailyDeals: TabsPane({
            tabContainerID: storeDailyDeals.tabsContainerID,
            innerComponent: await DailyDeals(),
            defaultDisplay: defaultActiveKey === storeDailyDeals.recallBizId,
        }),
        optionalWelfare: TabsPane({
            tabContainerID: storeOptionalWelfare.tabsContainerID,
            innerComponent: await OptionalWelfare(),
            defaultDisplay: defaultActiveKey === storeOptionalWelfare.recallBizId,
        }),
    };
    if (defaultActiveKey === storeDailyDeals.recallBizId) {
        data.dailyDealsDisplay = '';
        data.optionalWelfareDisplay = 'none';
        style.dailyDealsActiveStyle = style.active;
        style.optionalWelfareActiveStyle = '';
        describeCouponComponent.structure.push(DailyDeals.describe, OptionalWelfare.describe);
    } else if (defaultActiveKey === storeOptionalWelfare.recallBizId) {
        data.dailyDealsDisplay = 'none';
        data.optionalWelfareDisplay = '';
        style.dailyDealsActiveStyle = '';
        style.optionalWelfareActiveStyle = style.active;
        describeCouponComponent.structure.push(OptionalWelfare.describe, DailyDeals.describe);
    }
    const events = {
        onClickTabsLabel: async (key) => {
            // 更换标签样式
            if (key === storeDailyDeals.recallBizId) {
                dailyDealsActive();
            } else if (key === storeOptionalWelfare.recallBizId) {
                optionalWelfareActive();
            }
            if (isFunction(onClickTabsLabelCb)) {
                onClickTabsLabelCb(key);
            }
        },
    };
    CouponComponentReady();
    const component = createComponent(tpl, { data, style }, events);
    return component;
};
CouponComponent.describe = describeCouponComponent;
export default CouponComponent;
